import npsApi from '@/api/nps-api'

export default {
  state: {
    showNPSPopup: false,
    feedbackId: null
  },
  getters: {
    getShowNpsPopup (state) {
      return state.showNPSPopup
    },
    getFeedbackId (state) {
      return state.feedbackId
    }
  },
  mutations: {
    setShowNpsPopup (state, value) {
      state.showNPSPopup = value
    },
    setFeedbackId (state, value) {
      state.feedbackId = value
    }
  },
  actions: {
    SAVE_NPS_FEEDBACK ({ commit }, { payload, success, fail }) {
      npsApi.saveNpsFeedback(payload).then(response => {
        if (response.body.success) {
          commit('setShowNpsPopup', false)
          commit('setFeedbackId', null)
          success && success(response.body)
        } else {
          fail && fail()
        }
      }).catch(() => {
        fail && fail()
      })
    },
    CANCEL_NPS_FEEDBACK ({ commit }, { payload, success, fail }) {
      npsApi.cancelNpsFeedback(payload).then(response => {
        if (response.body.success) {
          commit('setShowNpsPopup', false)
          commit('setFeedbackId', null)
          success && success(response.body)
        } else {
          fail && fail()
        }
      }).catch(() => {
        fail && fail()
      })
    }
  },
  namespaced: true
}
